import { Component, OnInit } from '@angular/core';
import { TicketHistoryService } from '../../services/ticket-history.service';
import { Observable } from 'rxjs';
import { TicketHistory } from 'src/app/core/models/itinerary.model';

@Component({
  selector: 'app-ticket-history',
  templateUrl: './ticket-history.component.html',
  styleUrls: ['./ticket-history.component.scss']
})
export class TicketHistoryComponent implements OnInit {
  passengers$: Observable<TicketHistory[]>;
  constructor(private service: TicketHistoryService) {}

  ngOnInit(): void {
    this.passengers$ = this.service.getTicketHistory();
  }
}
